// features/flightsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching flights
export const fetchFlights = createAsyncThunk(
  "flights/fetchFlights",
  async (url, { rejectWithValue }) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("access")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const flightsSlice = createSlice({
  name: "flights",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    addFlight: (state, action) => {
      state.data.push(action.payload);
    },
    invalidateFlights: (state) => {
      state.data = []; // Clear flights when invalidated
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlights.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFlights.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFlights.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addFlight, invalidateFlights } = flightsSlice.actions;
export default flightsSlice.reducer;
